export enum PlayerState {
  Playing = "Playing",
  Idle = "Idle",
  Buffering = "Buffering",
  Ended = "Ended",
}
